import React from 'react'
import CategoryList from "../../components/CategoryList/CategoryList";

export default function Categories({navigation, route}) {
    if(route.params.appData){
        return (
            <CategoryList appData={route.params.appData} navigation={navigation} />
        )
    } else {
        return null
    }
}